import { render, staticRenderFns } from "./2-AdditionalQuestions.vue?vue&type=template&id=320b0b5d&scoped=true"
import script from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b0b5d",
  null
  
)

export default component.exports